export default "__VITE_ASSET__8b77c79a__"